
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/partners-terms",
      function () {
        return require("private-next-pages/policy/partners-terms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/partners-terms"])
      });
    }
  